import React from 'react';
import { BigEggHeaderLogo } from '@chegg-ui/theme';
import { LogoLink } from '../styles.retrofit';

var BigEggHeaderLogoLink = function BigEggHeaderLogoLink(_ref) {
  var envUrl = _ref.envUrl,
      onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(LogoLink, {
    href: envUrl,
    onClick: onClick,
    "data-test": "header-logo"
  }, /*#__PURE__*/React.createElement(BigEggHeaderLogo, null));
};

export default BigEggHeaderLogoLink;